export const ANNOUNCEMENTS_ENDPOINT = "/announcements/v1";
export const AUDIT_ENDPOINT = "/audit/v1";
export const AUTH_ENDPOINT = "/auth/v1";
export const COMMUNITY_ENDPOINT = "/community/v2";
export const FILES_ENDPOINT = "/files/v1";
export const GET_CSRF_ENDPOINT = "/csrf";
export const INSIGHTS_ENDPOINT = "/insights/v1";
export const LICENSING_ENDPOINT = "/licensing/v1";
export const ORGANIZATIONS_ENDPOINT = "/organizations/v1";
export const POLICY_CONFIG_ENDPOINT = "/policy/v1";
export const PROJECTS_ENDPOINT = "/projects/v1";
export const REPORTS_ENDPOINT = "/reports/v1";
export const SHARED_REPORTS_ENDPOINT = "/shared-reports/v1";
export const SOFTWARE_CATALOG_ENDPOINT = "/software-catalog/v1";
export const USERS_ENDPOINT = "/users/v1";
